export const IMAGES = {
  // Логотипы и иконки
  logo: "/elements/logo.svg",
  searchIcon: "/elements/searchIcon.svg",
  dot: "/elements/dot.svg",
  advantagesStick: "/elements/advantagesStick.svg",
  locationAndRoutesStick: "/elements/locationAndRoutesStick.svg",
  
  // Основные фото
  mainPhoto: "/elements/mainPhoto.png",
  advantages1: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/advantages1.png",
  advantages2: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/advantages2.png",
  advantages3: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/advantages3.png",
  advantages4: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/advantages4.png",
  advantages5: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/advantages5.png",
  
  // Карточки
  locations: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/locations.png",
  routes: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/routes.png",
  
  // Рекомендации
  recommendPhoto1: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/recommendPhoto1.png",
  recommendPhoto2: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/recommendPhoto2.png",
  recommendPhoto3: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/recommendPhoto3.png",
  recommendPhoto4: "https://spb4you-multimedia-content.hb.ru-msk.vkcloud-storage.ru/recommendPhoto4.png",
  
  // Соцсети
  telegramIcon: "/elements/telegramIcon.svg",
  VKIcon: "/elements/VKIcon.svg",
  mailIcon: "/elements/mailIcon.svg"
};